export const MOBILE_WIDTH = 450;
export const TABLET_WIDTH = 900;
